import React from 'react';
import _ from 'lodash';
import ActionButton from './ActionButton';

const FaqsForSubscription = ({ faqs, setFaqs, isEditor = true }: { faqs: any; setFaqs?: any; isEditor?: boolean }) => {
  const handleDataChange = (index, value) => {
    const newFaqs = _.clone(faqs);
    newFaqs[index] = value;
    setFaqs(newFaqs);
  };

  const handleAddFaq = () => {
    const newFaqs = _.clone(faqs);
    newFaqs.push({ question: '', answer: '' });
    setFaqs(newFaqs);
  };

  const handleRemoveFaq = (index) => {
    const newFaqs = _.clone(faqs);
    newFaqs.splice(index, 1);
    setFaqs(newFaqs);
  };

  const getFaqInputs = () => {
    return faqs.map((faq, index) => (
      <div className="card mb-3" key={index}>
        <div className="card-header">FAQ {(1 + index)}</div>
        <div className="card-body">
          <label className='text-muted'>Question</label>
          <input
            type="text"
            className="form-control mb-2"
            value={faq.question}
            onChange={(e) => handleDataChange(index, { ...faq, question: e.target.value })}
            placeholder="Question"
          />
          <label className='text-muted'>Answer</label>
          <input
            type="text"
            className="form-control"
            value={faq.answer}
            onChange={(e) => handleDataChange(index, { ...faq, answer: e.target.value })}
            placeholder="Answer"
          />
          <button
            className="btn btn-danger mt-2"
            onClick={() => handleRemoveFaq(index)}
          >
            Remove
          </button>
        </div>
      </div>
    ));
  };

  const getFaqsEditor = () => {
    if (isEditor) {
      return (
        <>
          {getFaqInputs()}
          <ActionButton
            active
            isLoading={false}
            onClick={handleAddFaq}
            text={'+ Add FAQ'}
          />
        </>
      );
    } else {
      return getFaqsPreviewer();
    }
  };

  const getFaqsPreviewer = () => {
    return faqs.map((faq, index) => (
      <div className="card mb-3" key={index}>
        <div className="card-header">FAQ {index + 1}</div>
        <div className="card-body">
          <h4>{faq.question}</h4>
          <div>{faq.answer}</div>
        </div>
      </div>
    ));
  };

  return (
    <div className="container mt-5">
      {getFaqsEditor()}
    </div>
  );
};

export default FaqsForSubscription;
